import React, { useState } from "react";
import { Link, NavLink, useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import UsekoLogo from "@/components/common/UsekoLogo";
import {
  LayoutDashboard, FolderKanban, Newspaper, Bell, Users, Grid3x3,
  Send, HeartHandshake, Handshake, MessageSquare, FileText, Settings, LogOut, Menu, X, Megaphone
} from "lucide-react";

const menu = [
  { path: "/admin/dashboard", label: "Genel Bakış", icon: LayoutDashboard },
  { path: "/admin/projects", label: "Projeler", icon: FolderKanban },
  { path: "/admin/news", label: "Haberler", icon: Newspaper },
  { path: "/admin/announcements", label: "Duyurular", icon: Bell },
  { path: "/admin/activity-areas", label: "Faaliyet Alanları", icon: Grid3x3 },
  { path: "/admin/popups", label: "Pop-up Görseli", icon: Megaphone },
  { path: "/admin/board", label: "Yönetim Kurulu", icon: Users },
  { path: "/admin/applications/membership", label: "Üyelik Başvuruları", icon: Send },
  { path: "/admin/applications/volunteer", label: "Gönüllü Başvuruları", icon: HeartHandshake },
  { path: "/admin/applications/partnership", label: "İş Birliği Başvuruları", icon: Handshake },
  { path: "/admin/contact", label: "İletişim Mesajları", icon: MessageSquare },
  { path: "/admin/documents", label: "Belgeler", icon: FileText },
  { path: "/admin/settings", label: "Site Ayarları & SEO", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#F7F9FA] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className={`fixed lg:sticky top-0 h-screen bg-white border-e border-[#E5E7EB] w-72 flex-shrink-0 z-40 transition-transform flex flex-col ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-6 border-b border-[#E5E7EB] flex items-center justify-between flex-shrink-0">
          <Link to="/" className="flex items-center gap-2.5">
            <UsekoLogo className="h-8 w-auto"/>
            <span className="text-[10px] uppercase tracking-widest text-[#4B5563] font-semibold">Admin</span>
          </Link>
          <button onClick={() => setOpen(false)} className="lg:hidden p-1" aria-label="close"><X className="w-5 h-5"/></button>
        </div>
        <nav className="flex-1 min-h-0 overflow-y-auto p-4 space-y-1">
          {menu.map((m) => {
            const Icon = m.icon;
            return (
              <NavLink
                key={m.path}
                to={m.path}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-[#EAF7F0] text-[#0F5132]" : "text-[#4B5563] hover:bg-[#F7F9FA] hover:text-[#102A43]"}`}
                data-testid={`nav-${m.path.split("/").pop()}`}
              >
                <Icon className="w-4 h-4"/>
                {m.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-4 border-t border-[#E5E7EB] bg-white flex-shrink-0">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 rounded-full bg-[#EAF7F0] flex items-center justify-center text-[#0F5132] font-bold text-sm">{(user?.name || "U")[0]}</div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium text-[#102A43] truncate">{user?.name}</div>
              <div className="text-xs text-[#4B5563] truncate">{user?.email}</div>
            </div>
          </div>
          <button onClick={handleLogout} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-[#4B5563] hover:bg-[#F7F9FA]" data-testid="admin-logout">
            <LogOut className="w-4 h-4"/> Çıkış
          </button>
        </div>
      </aside>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="lg:hidden sticky top-0 z-30 bg-white border-b border-[#E5E7EB] px-4 py-3 flex items-center gap-3">
          <button onClick={() => setOpen(true)} className="p-1" aria-label="menu"><Menu className="w-5 h-5"/></button>
          <span className="font-heading font-bold text-[#102A43]">USEKO Admin</span>
        </div>
        <div className="p-6 md:p-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
